module.exports = __webpack_public_path__ + "img/baa4ac7.png";